import {
  TypographyCaption,
  TypographyH2,
  TypographyP,
  TypographyP2,
} from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { Files, Send, Settings2 } from 'lucide-react';

export function TemplateLoadingStep() {
  const { t } = useTranslations();

  const tips = [
    { icon: Settings2, text: t('signup.templateTip1') },
    { icon: Files, text: t('signup.templateTip2') },
    { icon: Send, text: t('signup.templateTip3') },
  ];

  return (
    <div className="flex h-full w-[400px] flex-col gap-10">
      {/* Header */}
      <div className="flex flex-col gap-4">
        <TypographyH2>{t('signup.creatingTemplate')}</TypographyH2>
        <TypographyP className="text-text-primary">
          {t('signup.creatingTemplateHint')}
        </TypographyP>
      </div>

      {/* Tips card */}
      <div className="flex flex-col gap-4 rounded-xl bg-background-secondary p-6">
        <TypographyCaption className="font-semibold text-text-secondary">
          {t('signup.didYouKnow')}
        </TypographyCaption>
        {tips.map((tip) => (
          <div key={tip.text} className="flex items-center gap-3">
            <tip.icon size={20} className="shrink-0 text-text-secondary" />
            <TypographyP2 className="text-text-secondary">{tip.text}</TypographyP2>
          </div>
        ))}
      </div>
    </div>
  );
}
